import _slicedToArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useReducer } from 'react';

var reducer = function reducer(value) {
  return (value + 1) % 1e6;
};

function useForceUpdate() {
  var _useReducer = useReducer(reducer, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      update = _useReducer2[1];

  return update;
}

export { useForceUpdate };